import 'twin.macro';
import React from 'react';
import { useLimitReached } from './useLimitReached';
import { useBillingInfos } from 'queries/useBillingInfos';
import { LimitReachedDialog } from './LimitReachedDialog';

export interface Props {
  item:
    | 'event'
    | 'evaluation'
    | 'programmation'
    | 'seance'
    | 'appel'
    | 'operation';
  onCancel?: () => void;
}

export function LimitReached(props: Props) {
  const { item, onCancel: originalOnCancel } = props;
  const { isOpen, close, requiredPlan, limit } = useLimitReached();
  const { isLoading, data: billingInfos } = useBillingInfos();

  if (isLoading || !billingInfos) {
    return <div tw="h-16 w-48" className="tsh-skeleton" />;
  }

  const handleCancel = () => {
    close();
    if (originalOnCancel) {
      originalOnCancel();
    }
  };

  return (
    <LimitReachedDialog
      isOpen={isOpen}
      item={item}
      limit={limit || 0}
      requiredPlan={requiredPlan || ''}
      billingInfos={billingInfos}
      onCancel={handleCancel}
    />
  );
}
